import { Injectable } from '@angular/core';

import * as firebase from "firebase/app"
import "firebase/auth"
import { Router } from '@angular/router';
import { FirestoreService } from './firestore.service';
import { getAuth, GoogleAuthProvider, onAuthStateChanged, signInWithPopup, signInWithRedirect, signOut, User } from 'firebase/auth';
import { BehaviorSubject, Observable } from 'rxjs';
import { GlobalsService } from './globals.service';

declare var gapi: any;


@Injectable({
  providedIn: 'root'
})

export class AuthService {

  auth = getAuth()

  user: User

  

  constructor(
    public router: Router,
    private firestoreService: FirestoreService,
    private globalsService: GlobalsService
  ) {
    this.authWatcher()
  }

  authWatcher() {
    onAuthStateChanged(this.auth, async user => {
      this.globalsService.authSubject.next(user)
      if(user) {
        console.log("signed in")

        this.globalsService.userAccountSubject.next(await this.firestoreService.getUserAccount(user.uid))

        if(!this.globalsService.userAccountSubject.value) {
          await this.firestoreService.createUserAccount(user)
        }

        this.user = user
        this.firestoreService.watchBankAccounts()
      } else {
        console.log("signed out")
        this.user = undefined
      }
    })
  }
  
  async loginServiceAccount() {
    try {
      const provider = new GoogleAuthProvider();
      provider.setCustomParameters({hd: "dorado.com.au"})
  
      await signInWithPopup(this.auth, provider)
    } catch(error) {
      console.log(error)
    }
  }

  signout() {
    return signOut(this.auth)
  }

}
